import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IChosenUser, IUsersStore } from './types/user-schemas';

export const usersInitialState: IUsersStore = {
    users: [],
    chosenUser: null,
    deleteModal: false,
    changePasswordModal: 0,
};

const usersSlice = createSlice({
    name: 'users',
    initialState: usersInitialState,
    selectors: {
        getChosenUser: (state) => state.chosenUser,
        getDeleteModal: (state) => state.deleteModal,
        getChangePasswordModal: (state) => state.changePasswordModal,
    },
    reducers: {
        toggleDeleteModal: (state, action: PayloadAction<boolean>) => {
            state.deleteModal = action.payload;
        },
        setChosenUser: (state, action: PayloadAction<IChosenUser | null>) => {
            state.chosenUser = action.payload;
        },
        toggleChangePasswordModal: (state, action: PayloadAction<number>) => {
            state.changePasswordModal = action.payload;
        },
    },
});

//actions
export const { actions: usersActions, selectors: usersSelectors } = usersSlice;

//reducer
export default usersSlice.reducer;
